export const WALLET_SCOPE = "nfid.one"
export const WALLET_SESSION_TTL = BigInt(10 * 60 * 1e9)
export const WALLET_SESSION_TTL_2_MIN_IN_NS = 2 * 60 * 1e9
export const WALLET_SESSION_TTL_1_MIN_IN_MS = 60000
